import { EntityRating, RecordingAsset, useRatingProviders } from '@kaltura-ott/tvpil-shared';

export const useRating = (recording: RecordingAsset, shouldShowRating: boolean | undefined) => {
  const { ratingProviders } = useRatingProviders();
  const ratingName = recording.rating?.name;
  const rating = ratingName
    ? ({ ...ratingProviders.get(ratingName), value: recording.rating?.value } as EntityRating)
    : undefined;

  const isDisplayRating = Boolean(shouldShowRating && rating);

  return { isDisplayRating, rating };
};
